import { useState } from "react";

function AddStudent() {
  const [fullName, setFullName] = useState("");
  const [course, setCourse] = useState("");
  const [dob, setDob] = useState("");
  const [gender, setGender] = useState("");
  const [contact, setContact] = useState("");
  const [residence, setResidence] = useState("");

  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await fetch("https://student-backend-infs-202.onrender.com/students", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          name: fullName,
          course,
          dob,
          gender,
          contact,
          residence,
        }),
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message);
      }

      setMessage(data.message);
      setError("");

      setFullName("");
      setCourse("");
      setDob("");
      setGender("");
      setContact("");
      setResidence("");

    } catch (err) {
      setError(err.message || "Error adding student");
      setMessage("");
    }
  };

  const styles = {
    container: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      minHeight: "100vh",
      backgroundColor: "#f5f5f5",
      padding: "20px",
    },

    card: {
      width: "100%",
      maxWidth: "420px",
      padding: "30px",
      borderRadius: "12px",
      backgroundColor: "#ffffff",
      border: "1px solid #ddd",
      textAlign: "center",
      color: "#000",
    },

    form: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",   // ✅ centers inputs
      width: "100%",
    },

    input: {
      width: "90%",            // ✅ prevents edge touching
      padding: "12px",
      margin: "8px 0",
      borderRadius: "6px",
      border: "1px solid #ccc",
      boxSizing: "border-box",
    },

    button: {
      width: "90%",            // ✅ matches inputs
      padding: "12px",
      backgroundColor: "#000",
      color: "#fff",
      borderRadius: "6px",
      cursor: "pointer",
      fontWeight: "bold",
      border: "none",
      marginTop: "10px",
    },

    errorText: {
      color: "red",
      marginTop: "10px",
    },

    messageText: {
      color: "green",
      marginTop: "10px",
    },
  };

  return (
    <div style={styles.container}>
      <div style={styles.card}>

        <h1>Add Student</h1>

        <form onSubmit={handleSubmit} style={styles.form}>
          <input
            placeholder="Full Name"
            value={fullName}
            onChange={(e) => setFullName(e.target.value)}
            style={styles.input}
          />

          <input
            placeholder="Course"
            value={course}
            onChange={(e) => setCourse(e.target.value)}
            style={styles.input}
          />

          <input
            type="date"
            value={dob}
            onChange={(e) => setDob(e.target.value)}
            style={styles.input}
          />

          <input
            placeholder="Gender"
            value={gender}
            onChange={(e) => setGender(e.target.value)}
            style={styles.input}
          />

          <input
            placeholder="Contact"
            value={contact}
            onChange={(e) => setContact(e.target.value)}
            style={styles.input}
          />

          <input
            placeholder="Residence"
            value={residence}
            onChange={(e) => setResidence(e.target.value)}
            style={styles.input}
          />

          <button type="submit" style={styles.button}>
            Add
          </button>
        </form>

        {error && <p style={styles.errorText}>{error}</p>}
        {message && <p style={styles.messageText}>{message}</p>}
      </div>
    </div>
  );
}

export default AddStudent;